/* eslint-disable */

import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/pro-regular-svg-icons/faUpload'
import { Helmet } from 'react-helmet'
import { faDownload } from '@fortawesome/pro-regular-svg-icons/faDownload'

import {
    HydraTable,
    Heading,
    TextFilter,
    StyledCheckbox,
} from '@peracto/peracto-ui'

import { GET_LIST, useClient } from '@peracto/client'
import { useConfig } from "@peracto/peracto-config";

const ProductRestrictionsList = () => {
    // Default visible columns - key = column accessor
    const [selectedColumns, onSelectColumn] = useState()

    const { client } = useClient()
    const config = useConfig()
    const { productRestrictions } = config.get('features', {})


    // The 'selectable' property is used to define if the
    // column is available in the 'manage columns' dropdown
    const columns = useMemo(() => [
        {
            Header: 'SKU',
            accessor: 'sku',
            sortType: 'basic',
            selectable: false,
        },
        {
            Header: 'SKU',
            accessor: 'product.sku',
            sortType: 'basic',
            Filter: props => <TextFilter label="SKU" {...props} />,
            selectable: false,
            show: false,
        },
        {
            Header: 'Account Number',
            accessor: 'accountNumber',
            sortType: 'basic',
            Filter: props => <TextFilter label="Account Number" {...props} />,
            selectable: false,
        },
        {
            Header: 'Full Restricted',
            accessor: 'fullRestriction',
            sortType: 'basic',
            Filter: props => <TextFilter label="Full Restricted" {...props} />,
            selectable: false,
        }
    ])

    const onFetchData = options => client(GET_LIST, 'product-restrictions', options)

    return (
        <>
            <Helmet>
                <title>Product Restrictions | Peracto</title>
            </Helmet>
            <Heading name="Product Restrictions">
                <div className="ml-2 d-flex align-items-center">
                    {productRestrictions?.exportData === true && (
                        <Link
                            className="mr-2 btn btn-link"
                            to="/product-restrictions/export"
                            data-testid="export-product-restrictions"
                        >
                            <FontAwesomeIcon icon={faDownload} className="mr-2" />
                            Export Product Restrictions Data
                        </Link>
                    )}
                    <Link
                        className="mr-2 btn btn-outline-primary"
                        data-testid="import-product-restrictions"
                        to="/product-restrictions/import"
                    >
                        <FontAwesomeIcon icon={faUpload} className="mr-2" />
                        Import Product Restrictions Data
                    </Link>
                </div>
            </Heading>

            <div className="row">
                <div className="col">
                    <div className="card card--transparent">
                        <div className="card-body">
                            <HydraTable
                                columns={columns}
                                selectedColumns={selectedColumns}
                                onFetchData={onFetchData}
                                onSelectColumn={onSelectColumn}
                                defaultFilters={{
                                    fromUrl: '',
                                    toUrl: '',
                                    active: 'true',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductRestrictionsList
